
import React from 'react';
import { useLocation } from 'react-router-dom';

import Footer from './Footer';

// The role dashboards (creator / reviewer / approver / super admin) run inside
// RoleLayout, which sizes itself to the viewport minus the navbar and scrolls
// its own content. Rendering the marketing footer underneath that pushes the
// document past 100vh, which gives the page a second scrollbar and a blank
// strip below the layout. Those screens are app chrome, not marketing pages, so
// the footer is simply left out.
const ROLE_SHELL_PREFIXES = ['/admin', '/reviewer', '/approver', '/super-admin'];

const AppFooter = () => {
  const { pathname } = useLocation();

  const inRoleShell = ROLE_SHELL_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

  return inRoleShell ? null : <Footer />;
};

export default AppFooter;
